import { IMenuResponse, IMenuItemResponse } from "models/response/menu-response";

export interface NavItem {
    label: string;
    route: string;
    isExternal?: boolean;
    items?: NavItem[];
}

const isExternalUrl = (url: string): boolean => {
    return url.startsWith('http://') || url.startsWith('https://');
};

export const mapMenuItemToNavItem = (item: IMenuItemResponse): NavItem => {
    const route = item.externalUrl || item.url || '#';
    return {
        label: item.title,
        route,
        isExternal: isExternalUrl(route),
    };
};

export const mapMenuToNavItem = (menu: IMenuResponse): NavItem => {
    const route = menu.externalUrl || menu.url || '#';
    return {
        label: menu.title,
        route,
        isExternal: isExternalUrl(route),
        items: menu.items && menu.items.length > 0
            ? menu.items
                .sort((a, b) => a.order - b.order)
                .map(mapMenuItemToNavItem)
            : undefined,
    };
};

export const mapMenusToNavItems = (menus: IMenuResponse[]): NavItem[] => {
    return menus
        .sort((a, b) => a.order - b.order)
        .map(mapMenuToNavItem);
};
